<template>
          <v-dialog v-model="showDialog" persistent scrollable max-width="600">
          <v-card>
						<v-card-title> 
							<span class="col-12">¿Dónde puedo encontrar mi NAF?</span>          
						</v-card-title>
						<!--<v-card-title v-if="titulo" class="text-body-1">
							Ejemplo de '{{titulo}}'
						</v-card-title>-->
            <!--<v-card-title class="headline">Ejemplo</v-card-title>-->
            <v-card-text class="pt-1 pb-0">
							<v-row>
								<v-col>
									<span>
									<b>¿Qué es el NAF?</b><br/>
									El número de seguridad social, también conocido como NAF, permite acceder a prestaciones y coberturas de la Seguridad Social.<br/><br/>
									<b>¿Dónde puedes encontrar el NAF?</b><br/>
									Si ha sido trabajador por cuenta ajena y no conoce su NAF, o quiere verificar que es el correcto, puede hacerlo a través de estas vías:<br/>
									<ul>
										<br/>
										<li>En una nómina:
											<v-img contain :src="require('../../assets/ejemplo-nomina.svg')" class="pt-4" />
										</li>
										<br/>
										<li>
											En un contrato de trabajo:
											<v-img contain :src="require('../../assets/ejemplo-contrato.svg')" class="pt-4" />
											<br/>
											También puedes encontrarlo en la tarjeta sanitaria.
											<v-img contain :src="require('../../assets/ejemplo-SIP.svg')" class="pt-4" />
											En su informe de vida laboral, que puedes <a href="https://portal.seg-social.gob.es/wps/portal/importass/importass/Categorias/Vida+laboral+e[…]es+sobre+tu+situacion+laboral/Informe+de+tu+vida+laboral" target="_blank">solicitar en la web del ministerio</a> con tu clave PIN, con certificado digital o vía SMS.
											<v-img contain :src="require('../../assets/ejemplo-vida-laboral.svg')" class="pt-4" />
											<br/>
											También puede <a href="https://sede.seg-social.gob.es/wps/portal/sede/sede/Ciudadanos/Informes+y+Certificados/201832" target="_blank">acreditar su NAF en la web del ministerio</a>.
										</li>
									</ul>
									</span>									
								</v-col>
							</v-row>
							</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
								color="rgb(18, 77, 145)"
								text
								class="text-decoration-underline"
								@click="showDialog = false"
							>
								Cerrar
							</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
</template>

<script>
 
export default {
	name: 'AyudaNAFDialog',
	data() {
    return {
			showDialog: false
		}
  },  
  methods: {
    open() {
      this.showDialog = true;
    },
	},
}
</script>